import { useEffect, useState } from 'react';
import {
  AgxBodyText,
  AgxButton,
  AgxCaption,
  AgxControlledCheckbox,
  AgxRow,
} from '@urbanx/agx-ui-components';
import { reloadRealEstate } from 'features/realEstate/realEstateReducer';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { formatCurrencyAsNumber } from 'utils/formatNumber';
import { LoadingState } from 'utils/loadingState';

interface RealEstateItemProps {
  id: string;
  productName: string;
  selected: boolean;
  onSelectProductChange: (value: {
    id: string;
    productName: string;
    pricePerUnit?: number;
    value: boolean;
  }) => void;
}

const RealEstateItem = ({
  id,
  productName,
  selected,
  onSelectProductChange,
}: RealEstateItemProps) => {
  const dispatch = useAppDispatch();
  const { loadingState: realEstateLoadingState, contract } = useAppSelector(
    state => state.realEstate
  );

  const [productSelected, setProductSelected] = useState(
    realEstateLoadingState !== LoadingState.Failed && selected
  );

  useEffect(() => {
    setProductSelected(selected === true);
  }, [selected]);

  useEffect(() => {
    onSelectProductChange({
      id,
      productName,
      pricePerUnit: contract?.price,
      value: realEstateLoadingState !== LoadingState.Failed && productSelected,
    });
  }, [productSelected]);

  let realEstateItemBody;

  if (realEstateLoadingState === LoadingState.Failed) {
    realEstateItemBody = (
      <AgxCaption>
        <AgxButton
          small
          naked
          onClick={() => {
            dispatch(reloadRealEstate());
          }}
          text={`Failed to retrieve ${productName} pricing. Click here to try again`}
        ></AgxButton>
      </AgxCaption>
    );
  } else if (realEstateLoadingState === LoadingState.Loading) {
    realEstateItemBody = (
      <AgxBodyText small>Loading {productName} pricing</AgxBodyText>
    );
  } else {
    realEstateItemBody = (
      <AgxBodyText small>
        {contract != null
          ? `$${formatCurrencyAsNumber(contract.price?.toString(), 2)}`
          : 'Complimentary'}
      </AgxBodyText>
    );
  }

  return (
    <AgxRow
      fill
      spaceBetween
      centered
      mediumGap
      extraClasses="marketingPackageItem"
    >
      <AgxControlledCheckbox
        naked
        label={productName}
        checked={productSelected}
        disabled={realEstateLoadingState === LoadingState.Failed}
        onValueChanged={value =>
          setProductSelected(
            realEstateLoadingState !== LoadingState.Failed && value === true
          )
        }
        id={id}
      />
      {realEstateItemBody}
    </AgxRow>
  );
};

export default RealEstateItem;
